import { render } from "./ChatMessageItem.vue?vue&type=template&id=a254d640&scoped=true"
import script from "./ChatMessageItem.vue?vue&type=script&lang=js"
export * from "./ChatMessageItem.vue?vue&type=script&lang=js"

import "./ChatMessageItem.vue?vue&type=style&index=0&id=a254d640&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-a254d640"

export default script